// ServiceOrderObservationsModal.jsx
import { supabase } from "../../../utils/supabase";
import { useEffect, useState } from "react";

export default function ServiceOrderObservationsModal({
  open,
  onClose,
  serviceOrderId,
}) {
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  // Lee el scroll aunque esté bloqueado (body fixed con top negativo)
  const getScrollYLockedAware = () => {
    const top = document?.body?.style?.top;
    if (top && top.includes("px")) {
      const n = Math.abs(parseInt(top, 10));
      if (!Number.isNaN(n)) return n;
    }
    return window.scrollY || 0;
  };

  const restoreScroll = (y) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({ top: y, left: 0, behavior: "auto" });
      });
    });
  };

  useEffect(() => {
    if (!open || !serviceOrderId) return;

    let cancelled = false;

    supabase
      .from("service_orders")
      .select("general_observations")
      .eq("id", serviceOrderId)
      .single()
      .then(({ data }) => {
        if (cancelled) return;
        setValue(data?.general_observations || "");
      });

    return () => {
      cancelled = true;
    };
  }, [open, serviceOrderId]);

  async function save() {
    // Guardamos la posición ANTES del update (porque el update puede disparar re-render global)
    const y = getScrollYLockedAware();

    try {
      setSaving(true);

      const { error } = await supabase
        .from("service_orders")
        .update({ general_observations: value })
        .eq("id", serviceOrderId);

      if (error) throw error;

      // Cerrar modal
      onClose(true);

      // Blindaje extra: aunque haya refresh/re-render, volvemos a la posición
      setTimeout(() => restoreScroll(y), 30);
      setTimeout(() => restoreScroll(y), 120);
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  }

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/60 grid place-items-center z-50">
      <div className="bg-[#0F1115] border border-white/10 rounded-xl p-5 w-full max-w-lg">
        <h3 className="text-lg font-semibold mb-3">
          Observaciones de la Orden de Servicio
        </h3>

        <textarea
          className="w-full min-h-[140px] bg-black/40 border border-white/10 rounded-md p-2 text-sm"
          placeholder="Observaciones administrativas que saldrán impresas en la OS…"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />

        <div className="flex justify-end gap-2 mt-4">
          <button
            type="button"
            onClick={() => onClose(false)}
            disabled={saving}
          >
            Cancelar
          </button>

          <button type="button" onClick={save} disabled={saving}>
            {saving ? "Guardando…" : "Guardar"}
          </button>
        </div>
      </div>
    </div>
  );
}
